import { useEffect, useState } from "react";
import { useSearchContext } from "../../contexts/search.tsx";
import { SearchParam } from "../../models/searchParams/searchParam.ts";
import FormInput from "../form/FormInput.tsx";
import ScanBarcode from "./ScanBarcode.tsx";
import { ResultsCards, ResultsList } from "./results";

export const Search = ({
    handleAddItem,
    setShowSearch,

    displayResultsList = false,
    displayResultsCards = !displayResultsList,

    disableAlimentSearch = false,
    disableRecipeSearch = false,
    disableMealSearch = true
}: {
    handleAddItem?: any;
    setShowSearch?: any;

    displayResultsList?: boolean;
    displayResultsCards?: boolean;

    disableAlimentSearch?: boolean;
    disableRecipeSearch?: boolean;
    disableMealSearch?: boolean;
}) => {
    const { results, searchParam, setSearchParam } = useSearchContext();
    const [localSearchParam, setLocalSearchParam] = useState<SearchParam>(searchParam);
    useEffect(() => {
        setLocalSearchParam(searchParam);
    }, [searchParam])
    const [showScanBarcode, setShowScanBarcode] = useState<boolean>(false);
    const [enableScanBarcode, setEnableScanBarcode] = useState<boolean>(false);
    const [searchTypes, setSearchTypes] = useState<any>([]);
    const [showSearchTypes, setShowSearchTypes] = useState(false);
    useEffect(() => {
        var computeSearchTypes: any[] = [];
        if (disableAlimentSearch == false) computeSearchTypes.push({ name: 'Aliments', value: 'Aliment' });
        if (disableRecipeSearch == false) computeSearchTypes.push({ name: 'Recipes', value: 'Recipe' });
        if (disableMealSearch == false) computeSearchTypes.push({ name: 'Meals', value: 'Meal' })
        let defaultSearchType = computeSearchTypes.map(x => (x.value)).toString().replaceAll(',', '');
        handleSetSearchType(defaultSearchType);
        setShowSearchTypes(computeSearchTypes.length > 1);
        if (computeSearchTypes.length > 1)
            computeSearchTypes.unshift({ name: 'All', value: `${disableAlimentSearch == false ? 'Aliment' : ''}${disableRecipeSearch == false ? 'Recipe' : ''}${disableMealSearch == false ? 'Meal' : ''}` });
        setSearchTypes(computeSearchTypes);
    }, []);

    useEffect(() => {
        var shouldBeDisabled = localSearchParam.searchType == 'Recipe' || localSearchParam.searchType == 'Meal' || localSearchParam.searchType == 'RecipeMeal'
        setEnableScanBarcode(!shouldBeDisabled);
    }, [localSearchParam.searchType])

    const handleInputChange = (e: any) => {
        const { id, value } = e.target;

        setLocalSearchParam((prevData: SearchParam) => ({
            ...prevData,
            [id]: value
        }));
    };

    const handleScanBarCodeResult = (result: string) => {
        setLocalSearchParam((prevData: SearchParam) => ({
            ...prevData,
            searchTerm: result ?? null
        }));
    }

    const handleSetSearchType = (value: string) => {
        setLocalSearchParam((prev: SearchParam) => ({ ...prev, searchType: value }));
    }

    useEffect(() => {
        setShowScanBarcode(false);
        const delayDebounceFn = setTimeout(() => {
            setSearchParam(localSearchParam);
            sessionStorage.setItem('searchTerm', localSearchParam.searchTerm);
            sessionStorage.setItem('searchType', localSearchParam.searchType);
        }, 250);

        return () => clearTimeout(delayDebounceFn);
    }, [localSearchParam]);

    if (showScanBarcode == true)
        return <ScanBarcode handleResult={handleScanBarCodeResult} setShowScanBarcode={setShowScanBarcode} />

    return (
        <div>
            <div className="d-flex flex-row gap-2 mb-2">
                <FormInput
                    entity={localSearchParam}
                    handleInputChange={handleInputChange}
                    type="search"
                    fieldName="searchTerm"
                    label="Search"
                    append={enableScanBarcode ? <i className="bi bi-upc-scan" /> : undefined}
                    handleAppendOnClick={() => setShowScanBarcode(true)}
                    mb={0}
                />
                {setShowSearch && <button className="btn bg-body-secondary" type="button" onClick={() => setShowSearch(false)}>Done</button>}
            </div>
            {showSearchTypes &&
                <ul className={`list-group list-group-horizontal ${displayResultsList == true && results.length > 0 ? 'list-group-top' : ''}`}>
                    {searchTypes.map((searchType) => (
                        <li className={`list-group-item list-group-item-action ${displayResultsList == true && results.length > 0 ? 'list-group-top ' : ''}text-center px-0 py-auto w-${parseInt((100 / searchTypes.length).toString())} ${localSearchParam.searchType == searchType.value ? 'list-group-item-success' : ''}`} onClick={() => handleSetSearchType(searchType.value)} >{searchType.name}</li>
                    ))}
                </ul>}
            {displayResultsList && <ResultsList results={results} showSearchTypes={showSearchTypes} handleAddItem={handleAddItem} />}
            {displayResultsCards && <ResultsCards results={results} />}
        </div>
    )
}